import { useState, useEffect } from "react";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import Container from "@material-ui/core/Container";
import ContentLayoutDetailsHeader from "../../../Common/ContentLayoutDetailsHeader";
import { useDispatch, useSelector } from "react-redux";
import MultiStepForm from "./Multi Step Form/Form";
import {
  setFromSocketAvsChannelList,
  setAvsChannelList,
  setRecording,
  setOpenStreamCamera,
} from "../../../Redux/Actions/VideoStreamingActions";
import { getFromLocalStorage } from "../../../utils/webStorage";

const VideoStreamingDashboard = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const { socket } = useSelector((state) => state?.SocketData);
  const schoolId = getFromLocalStorage("schoolId");
  const userId = getFromLocalStorage("currentUserId");
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const { videoStreamAvsChannelList } = useSelector(
    (state) => state?.videoStreamData
  );

  useEffect(() => {
    setAvsChannelList(dispatch, schoolId);
  }, []);

  useEffect(() => {
    if (!socket) return;

    const handleStartStreaming = (data) => {
      const relevantData = data?.filter(
        (ele) => ele.homeSchool?.id == schoolId
      );
      relevantData.forEach((ele) => setFromSocketAvsChannelList(dispatch, ele));
    };

    const handleStopStreaming = (data) => {
      data.forEach((ele) => {
        if (userId === ele.userId.toString()) {
          setOpenStreamCamera(dispatch, false);
        }
        if (ele.homeSchool?.id == schoolId) {
          setFromSocketAvsChannelList(dispatch, ele);
        }
      });
    };

    const handleNewRecording = (data) => {
      if (data?.[0]?.schoolId == schoolId.toString()) {
        setRecording(dispatch, data);
      }
    };

    const events = [
      { name: "broadcastStartStreaming", handler: handleStartStreaming },
      { name: "broadcastStopStreaming", handler: handleStopStreaming },
      { name: "broadcastNewRecording", handler: handleNewRecording },
    ];

    // Attach socket listeners
    events.forEach(({ name, handler }) => socket.on(name, handler));

    return () => {
      // Cleanup listeners on unmount
      events.forEach(({ name, handler }) => socket.off(name, handler));
    };
  }, [socket, schoolId, userId]);

  useEffect(() => {
    if (videoStreamAvsChannelList.length == 0) {
      const sideBarElement = document.querySelector("#schoolAdminSidebar");
      if (sideBarElement) {
        sideBarElement.style.pointerEvents = "auto";
      }
      const headerElement = document.querySelector(".MuiToolbar-regular");
      if (headerElement) {
        headerElement.style.pointerEvents = "auto";
      }
    }
    if (videoStreamAvsChannelList.length > 0) {
      setPage(2);
    }
  }, [videoStreamAvsChannelList]);

  return (
    <div
      className={
        isDrawerOpen
          ? "content-layout add-sectionn p-0 position-relative"
          : "toggle-content-layout add-sectionn p-0 position-relative"
      }
    >
      <SchoolAdminDashboard />
      <ContentLayoutDetailsHeader label="Video Streaming" />
      <Container>
        <MultiStepForm page={page} setPage={setPage} socket={socket} />
      </Container>
    </div>
  );
};

export default VideoStreamingDashboard;
